export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      form: {},
      darr: [{
        name: '弹性布局',
        icon: 'icon-display-flex'
      }, {
        name: '块级布局',
        icon: 'icon-display-block'
      }, {
        name: '行内区块',
        icon: 'icon-display-inline-block'
      }, {
        name: '行内元素',
        icon: 'icon-display-inline'
      }],
      dIndex: 1
    };
  },
  watch: {
    value: {
      handler(val) {
        // console.log('typedisplay', val)
        if (Object.keys(val).length > 0) {
          this.styleback(val.display);
          let index = this.darr.findIndex(item => {
            return item.icon.includes(val.display);
          });
          this.dIndex = index;
        }
      },
      deep: true
    }
  },
  mounted() {
    // console.log(`this.value`, this.value)
    if (Object.keys(this.value).length === 0) {
      this.styleback('block');
    } else {
      this.styleback(this.value.display);
      let index = this.darr.findIndex(item => {
        return item.icon.includes(this.value.display);
      });
      this.dIndex = index;
    }
  },
  methods: {
    handleClick(val, index) {
      this.dIndex = index;
      let value = val.icon.replace('icon-display-', '');
      this.styleback(value);
    },
    styleback(val) {
      let obj = {};
      obj[this.title] = {
        display: val
      };
      this.$emit('display', obj);
    }
  }
};